import classNames from "lib/classNames";
import { selectButtonTheme } from "hardcover-ui/theme/components/select";
import { router } from "@inertiajs/react";

export type ReviewOrderType = "newest" | "oldest" | "likes" | "highest" | "lowest";

const options = [
  {
    title: "Sort By Date (Newest First)",
    value: "newest",
  },
  {
    title: "Sort By Date (Oldest First)",
    value: "oldest",
  },
  {
    title: "Most Liked",
    value: "likes",
  },
  {
    title: "Highest Rated",
    value: "highest",
  },
  {
    title: "Lowest Rated",
    value: "lowest",
  },
];

export default function OrderBySelect({
  order,
  url
}: {
  order: ReviewOrderType;
  url: string;
}) {
  function onChange(newOrder: ReviewOrderType) {
    const newUrl = newOrder === "newest" ? url : `${url}?order=${newOrder}`;
    router.visit(newUrl);
  }
  return (
    <div className="float-right">
      <select
        className={classNames(
          "pr-8",
          selectButtonTheme.variant.normal,
          selectButtonTheme.size.md
        )}
        onChange={(e) => onChange(options[e.target.selectedIndex].value as ReviewOrderType)}
        defaultValue={order}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.title}
          </option>
        ))}
      </select>
    </div>
  );
}
